// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"9bca1350","391":"dd462c2f","455":"e021a6ef","488":"1a9a8f8c","685":"729ef1fc","695":"44d1dced","977":"3d2c2926"}[chunkId] + ".chunk.js";
};